module.exports = "<div id=\"loader-wrapper\" class=\"loader-wrapper\">\n\t<div class=\"loader02\"></div>\n</div>\n"